import React, { useEffect, useState } from 'react';

import { ENavbarTypes } from '../../../../../../types/working-model';
import ModalComponent from "../../../../../general-ui/modal/modal";
import TabHeader from "../../../../../general-ui/tab-header/tab-header";
import { useTypedSelector } from "../../../../../../store/reducers/use-typed-selector";
import EventModalAdvancedSettings from "./event-modal-advanced-settings";
import EventHeaderModalContent from "./event-header-modal-content";
import { OptionalComponent } from "../../../../../../utils/optional-component";
import { EHeaderModalTabs, useOnSave } from './hooks/edit-navigation';

import './edit-event-header-modal.scss';

const TABS = [EHeaderModalTabs.layout];

interface IEditEventHeaderModalProps {
	open: boolean;
	closeModal: () => void;
}

export default function EditEventHeaderModal({ open, closeModal }: IEditEventHeaderModalProps): JSX.Element {
	const workingEvent = useTypedSelector(state => state.CreateEventReducer.workingEvent);

	const {
		navbarType: _navbarType,
		isSticky: _isSticky,
		isTransparent: _isTransparent
	} = workingEvent?.settings.event_navbar || {};
	
	const [activeTab, setActiveTab] = useState(EHeaderModalTabs.layout);
	const [navPosition, setNavPosition] = useState<ENavbarTypes | undefined>(_navbarType);
	const [isSticky, setIsSticky] = useState(!!_isSticky);
	const [isTransparent, setIsTransparent] = useState(!!_isTransparent);
	const onSave = useOnSave({ activeTab, navPosition, isSticky, isTransparent, closeModal });
	
	useEffect(() => {
		if (open) {
			setNavPosition(_navbarType);
			setIsSticky(!!_isSticky);
			setIsTransparent(!!_isTransparent);
		}
	}, [_isSticky, _isTransparent, _navbarType, open]);
	
	const isSideNavbar = navPosition === ENavbarTypes.Vertical;
	
	const footer = (
		<>
			<button onClick={closeModal}>Cancel</button>
			<button
				className='footer-menu-done primary'
				onClick={onSave}
			>
				Done
			</button>
		</>
	);

	return (
		<ModalComponent
			className="event-header-modal"
			cancellable={true}
			closeable={false}
			open={open}
			onRequestClose={closeModal}
			title="Header"
			padTitle={false}
			noSidePadding={true}
			footer={footer}
		>
			<TabHeader
				tabs={TABS}
				onClick={setActiveTab}
				currentTab={activeTab}
			/>
			<EventHeaderModalContent navPosition={navPosition} setNavPosition={setNavPosition} />
			<OptionalComponent display={!isSideNavbar}>
				<EventModalAdvancedSettings
					isSticky={isSticky}
					isTransparent={isTransparent}
					setIsSticky={setIsSticky}
					setIsTransparent={setIsTransparent}
				/>
			</OptionalComponent>
		</ModalComponent>
	);
}
